// removed by extract-text-webpack-plugin
module.exports = {"headerDescription":"_2ESsW6vygGOGLJvwzSUck-","studentPackagesTable":"_3IkPvnSUpzCZwcec7fsOri"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UserAcademicDownloads/UserAcademicDownloads.scss
// module id = 2764
// module chunks = 0